import * as React from 'react';
import styled from 'styled-components';
import { Checkbox, Text, LinkText, Colors } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';
import STATIC_COPY from '../../../constants/copy';
import { FilterSection } from './common';
import { breakpoints } from '../../../common/mediaQuery';

const Container = styled(FilterSection)`
  padding: 0 24px;
  border-right: 1px solid ${Colors.GREY16};

  @media screen and (max-width: ${breakpoints.mobile}px) {
    border-right: 0;
    border-bottom: 1px solid ${Colors.GREY16};
    padding: 0 0 16px 0;
  }
`;

const SmallLinkText = styled(LinkText)`
  font-size: 12px;
`;

const FuelCheckboxes = styled.div`
  display: flex;
  flex-direction: row;

  @media screen and (max-width: ${breakpoints.large}px) {
    flex-direction: column;
  }
`;

interface EnergyTypesProps {
  requiresElectricity: boolean;
  requiresGas: boolean;
  disableElectricity: boolean;
  disableGas: boolean;
  handleFuelRequirementChange: (which: string, selected: boolean) => void;
  hasSolarPanels: boolean;
  handleHasSolarPanelsChange: (event) => void;
  lpgCrossSellLink: string;
  handleGasBottleLinkClick: (event: React.MouseEvent<any, MouseEvent>) => void;
}

export class EnergyTypes extends React.Component<EnergyTypesProps> {
  handleElectricityChange = () => {
    this.props.handleFuelRequirementChange('electricity', !this.props.requiresElectricity);
  };

  handleGasChange = () => {
    this.props.handleFuelRequirementChange('gas', !this.props.requiresGas);
  };

  handleSolarChange = () => {
    this.props.handleHasSolarPanelsChange({ target: { checked: !this.props.hasSolarPanels } });
  };

  render = () => {
    const {
      requiresElectricity,
      requiresGas,
      disableElectricity,
      disableGas,
      hasSolarPanels,
      lpgCrossSellLink,
      handleGasBottleLinkClick,
    } = this.props;
    return (
      <Container>
        <Box marginBottom={4}>
          <Text size="sm" fontWeight="medium">
            Select energy type
          </Text>
        </Box>
        <Box display="flex" direction="row">
          <FuelCheckboxes>
            <Box marginRight={4}>
              <Checkbox
                checked={requiresElectricity}
                disabled={disableElectricity}
                name="electricity"
                onClick={this.handleElectricityChange}
                label="Electricity"
                data-id="electricity-checkbox"
              />
            </Box>
            <Box marginRight={4}>
              <Checkbox
                checked={requiresGas}
                disabled={disableGas}
                name="gas"
                onClick={this.handleGasChange}
                label="Natural gas"
                data-id="gas-checkbox"
              />
            </Box>
          </FuelCheckboxes>
          <Checkbox
            disabled={disableElectricity}
            checked={hasSolarPanels}
            name="solar"
            onClick={this.handleSolarChange}
            label="Solar"
            data-id="solar-checkbox"
          />
        </Box>
        <SmallLinkText
          href={lpgCrossSellLink}
          target="_blank"
          rel="noopener noreferrer"
          data-id="gas-bottle-link"
          onClickCapture={handleGasBottleLinkClick}
          text="Looking for LPG gas bottles?"
        />
      </Container>
    );
  };
}
